export const I18nConstant = {
  ua: {
    auth: {
      title: 'Авторизація',
      btn: 'Увійти',
    },
    chat: {
      'scenario.input.title.text': 'Текстовое сообщение',
      'scenario.input.title.buttons': 'Кнопки',
      'scenario.input.title.generate': 'Сгенерировать (вызов функции или шаблона)',
      'message.component.ai-message': 'Повідомлення АІ (за замовчуванням)',
      'message.component.card': 'Карточка',
      'message.component.link': 'Посилання',
      'scenario.fields.send': 'Сценарій',
      'scenario.fields.text': 'Текст кнопки',
      'scenario.fields.button.send': 'Сценарій кнопки',
      'fields.scenario': 'Сценарий',
      'fields.component': 'Компонент',
      'fields.call': 'Вызов функции',
      'fields.text': 'Текст',
      'fields.type': 'Тип',
      'fields.question.text': 'Текст питання',
      'fields.question.variable': 'Змінна для відповіді',
      'fields.question.withReject': 'Альтернативний сценарій',
      'fields.question.options.inputPlaceholder': 'Плейсхолдер відповіді',
      'fields.question.options.buttonReject': 'Текст кнопки альтернативного сценарію',
      'fields.question.sendOnResolve': 'Основний сценарій',
      'fields.question.sendOnReject': 'Альтернативний сценарій',
      'message.call': 'Виклик функції',
      'message.type': 'Тип повідомлення',
      'message.type.buttons': 'Кнопки',
      'message.type.text': 'Текст',
      'message.type.question': 'Питання',
      'message.type.generate': 'Генератор',
      'message.type.generator-resolve-reject': 'Генератор (resolve/reject)',
    },
    form: {
      email: 'Електронна пошта',
      password: 'Пароль',
      createdAt: 'Дата створення',
      statusId: 'Статус',
      save: 'Зберегти',
      send: 'Відправити',
      updatedAt: 'Дата оновлення',
      test: 'Тест',
      testResult: 'Результат тесту',
    },
    nav: {
      'custom-page': 'Конструктор сторінки',
      'custom-breadcrumb': 'Конструктор хлібних крихт',
      analytic: 'Аналітика',
      user_enterprise_profile: 'Профілі компаній',
      user_export_profile: 'Профілі експортера',
      user_import_profile: 'Профілі імпортера',
      user_tests: 'Тести користувачів',
      user_export_catalog_profile: 'Профілі каталогу експортерів',
      user_export_catalog_profile_question: 'Запити на профілі каталогу',
      user_import_catalog_profile: 'Профілі каталогу імпортерів',
      supporter: 'Підтримка',
      component: 'Картки',
      settings: 'Налаштування',
      entrepreneur_handbook_request: 'Запити на довідник підприємця',
      entrepreneur_handbook_question: 'Запитання щодо довідників підприємця',
      export_handbook_question: 'Запити на довідник експортера',
      notify: 'Сповіщення',
      general: 'Основне',
      generals: 'Основні',
      'social-links': 'Соціальні мережі',
      'menu-item': 'Пункти меню',
      menu: 'Меню',
      languages: 'Мови',
      service: 'Послуги',
      activityType: 'Напрями діяльності',
      annualTurnover: 'Річний оборот',
      employeesNumber: 'Кількість працівників',
      enterpriseSize: 'Розмір підприємства',
      organizationType: 'Типи орг.',
      ownershipType: 'Типи власності',
      organizationActivity: 'Діяльність орг.',
      loanType: 'Типи кредиту',
      topic: 'Теми',
      exportRegion: 'Регіони експорту',
      exportLocality: 'Місцевості експорту',
      exportProduct: 'Продукти експорту',
      entrepreneur_handbook_category: 'Категорії дов. підприємця',
      entrepreneur_handbook_type: 'Типи дов. підприємця',
      entrepreneur_handbook: 'Довідники підприємця',
      export_handbook_article: 'Довідник експортера',
      export_handbook_article_type: 'Типи дов. експортера',
      export_handbook_category: 'Категорії дов. експортера',
      export_handbook_link: 'Посилання дов. експортера',
      export_handbook_link_theme: 'Теми посилань дов. експортера',
      export_guide_category: 'Категорії Експортного гайду',
      export_guide: 'Експортний гайд',
      export_request: 'Запити',
      export_office: 'Експортний офіс',
      about: 'Про сайт',
      export_bank: 'Банки',
      export_helpdesk: 'Хелпдески',
      export_team: 'Команда',
      import_handbook_article: 'Довідник імпортера',
      import_handbook_article_type: 'Типи дов. імпортера',
      import_handbook_category: 'Категорії дов. імпортера',
      import_handbook_link: 'Посилання дов. імпортера',
      import_guide_category: 'Категорії Імпортного гайду',
      import_guide: 'Імпортний гайд',
      country_industry: 'Індустрії країн',
      sector: 'Сектори',
      country_partnership_request: 'Запити на партнерство країн',
      handbook: 'Довідники',
      filemanager: 'Файловий менеджер',
      translations: 'Переклади',
      main_question: 'Запити на головній',
      main_content_category: 'Категорії контенту',
      main: 'Головна',
      users: 'Користувачі',
      content: 'Контент',
      directory: 'Словники',
      region: 'Області',
      city: 'Міста',
      village: 'Села',
      review: 'Відгуки',
      expert_review: 'Відгуки експертів',
      expert_consultation: 'Консультації експертів',
      consultation_review: 'Відгуки консультацій',
      questionnaire: 'Оцінки',
      katottg: 'КАТОТТГ',
      business_parameter: 'Параметри бізнесу',
      criticality_level: 'Рівені критичності',
      enterprise_size: 'Розміри підприємства',
      entrepreneur_type: 'Типи підприємців',
      feedback_category: 'Категорія',
      feedback_option: 'Варіанти відгуку',
      feedback_status: 'Статуси',
      feedback_type: 'Типи відгуків',
      kved: 'КВЕД',
      ownership_type: 'Форми власності',
      state_authority: 'Органи держ. влади',
      tax_group: 'Групи оподаткування',
      bussines_assessment: 'Параметри бізнесу',
      state_authority_assessment: 'Інституції',
      search: 'Пошук',
      search_popular_request: 'Популярні запити',
      success_story: 'Історії успіху',
      success_story_advice: 'Історії успіху (слайдер)',
      success_story_category: 'Категорії',
      success_story_author: 'Автори',
      proposal: 'Пропозиції',
      proposal_assistance_type: 'Види допомоги',
      proposal_question: 'Запитання',
      dashboard: 'Дашбоард',
      analytic_dashboard: 'Дашбоарди',
      research: 'Дослідження',
      country_group: 'Групи країн',
      research_type: 'Типи досліджень',
      research_request: 'Замовлення досліджень',
      analytic_question: 'Часті запитання',
      analytic_addition: 'Додадкове',
      partners: 'Партнери',
      blog: 'Новини',
      blog_category: 'Теми',
      government: 'Урядова інформація',
      department: 'Офіси',
      country: 'Країни',
      industry: 'Індустрії',
      export_product: 'Продукти',
      expert: 'Експерти/Консультанти',
      blog_proposal: 'Пропозиції',
      finance_type: 'Типи',
      finance_category: 'Категорії',
      business_category: 'Катеорії бізнесу',
      currency: 'Валюти',
      finance_amount: 'Суми',
      finance_class: 'Види фінансування',
      finance_institution: 'Фінансові інституції',
      finance_product: 'Фінансові продукти',
      finance_provision: 'Забезпечення',
      finance_rate: 'Ставки',
      finance_term: 'Строки',
      loan_type: 'Типи кредитів',
      finance: 'Фінанси',
      finance_program: 'Фін. програми',
      finance_service: 'Фінансування',
      finance_attribute: 'Атрибути',
      finance_filter: 'Фільтри',
      finance_question: 'Запити',
      finance_handbook_category: 'Категорії довідників',
      finance_handbook: 'Довідники',
      finance_role_request: 'Запити на роль Маркетплейс',
      partnership: 'Партнерство з проєктом',
      partnership_contact_person: 'Контактні особи',
      partnership_request: 'Запити',
      partnership_area: 'Cфери партнерства',
      tender: 'Тендери',
      tender_request: 'Запити',
      tender_question: 'Запитання',
      chat: 'Chat',
      chat_scenarios: 'Chat scenarios',
      chat_callable: 'Chat callable',
      consultations: 'Консультації',
      expert_theme: 'Теми',
      expert_activity: 'Сфери',
      consultation_category: 'Категорії',
      consultation_channel: 'Канали',
      consultation: 'Консультації',
      user_consultation_quiz: 'Квізи',
      consultant_request: 'Запити консультацій',
      expert_question: 'Запитання',
      event: 'Події',
      event_theme: 'Теми',
      event_category: 'Категорії',
      idea_category: 'Категорії',
      event_speaker: 'Спікери',
      user_event_registration: 'Зворотня форма',
      user_education: 'Користувацькі',
      user_education_certificate: 'Користувацькі сертифікати',
      tools: 'Інструменти',
      idea: 'Ідеї',
      uktzed: 'УКТЗЕД',
      test: 'Тести',
      export: 'Експорт',
      export_service_category: 'Категорії послуг',
      export_service: 'Послуги',
      export_trade_agreement: 'Угоди',
      export_service_request: 'Запити послуг',
      export_service_request_report: 'Скарги на запити послуг',
      export_brand_logo: 'Логотипи',
      export_brand_file: 'Бренд файли',
      tools_service: 'Сервіси',
      import_category: 'Категорії',
      import: 'Імпорт',
      import_service_category: 'Категорії послуг',
      import_service: 'Послуги',
      import_trade_agreement: 'Угоди',
      import_service_request: 'Запити послуг',
      initiative: 'Ініціативи',
      center: 'Дія центри',
      education_category: 'Категорії',
      education_format: 'Формати',
      education_organizer: 'Організатори',
      education_theme: 'Напрямки',
      education: 'Освіта',
      course_category: 'Категорії',
      course_format: 'Формати',
      course_organizer: 'Організатори',
      course_theme: 'Напрямки',
      course_dialog: 'Чати',
      user_course: 'Курси користувачів',
      course: 'Курси',
      course_review: 'Відгуки',
      user_lms_teacher_profile: 'Профілі вчителів',
      course_test: 'Тести',
      user_course_test: 'Тести користувачів',
      course_homework: 'Домашне завдання',
      user_course_homework: 'ДЗ користувачів',
      user_course_stats: 'Статистика',
      user_course_analytics: 'Аналітика',
      event_propose: 'Пропозициї',
      education_review: 'Відгуки',
      education_registration: 'Реєстрації',
      expert_request: 'Запити експертів',
      mail: 'Email листи',
      mail_admin: 'Адміністратори розсилки',
      page_partner: 'Партнери',
      user_profile_filter: 'Фільтри',
      log: 'Логи',
      robots: 'Robots.txt',
      analytic_tool: 'Вибір ринку',
      analytic_report: 'Звіти',
      analytic_tool_config: 'Конфіги',
      analytic_country: 'Країни',
      analytic_country_group: 'Групи країн',
      analytic_organization: 'Організації',
    },
    general: {
      breadcrumbs: 'Хлібні крихти',
      partner: 'Партнери',
      apply: 'Застосувати',
      documents: 'Документи',
      certification: 'Сертифікати',
      files: 'Файли',
      answers: 'Відповіді',
      actions: 'Дії',
      imageColumn: 'Стовбець з зображеннями',
      column1: 'Стовбець 1',
      column2: 'Стовбець 2',
      column3: 'Стовбець 3',
      column4: 'Стовбець 4',
      list: 'Випадаючий список',
      field: 'Обрати',
      btn1: 'Обрати',
      btn1_remove: 'Видалити',
      btn1_edit: 'Редагувати',
      btn1_download: 'Завантажити',
      add_file: 'Завантажити',
      images: 'Файли',
      attributes: 'Атрибути',
      file_picker: 'Обрати файл',
      file_title: 'Посилання на файл',
      constructor: 'Конструктор',
      new_block: 'Новий блок',
      remove_block: 'Видалити блок',
      move_up_block: 'Вверх',
      move_down_block: 'Вниз',
      remove_program: 'Видалити програму',
      new_item: 'Новий елемент',
      remove_item: 'Видалити елемент',
      total_count: 'Загальна кількість:',
      per_page: 'Відображати',
      order_by: 'Сортувати',
      filters: 'Фільтри',
      csv: 'Завантажити CSV',
      create: 'Створити',
      order: 'Порядок',
      edit: 'Ред.',
      delete: 'Видалити',
      before_delete:
        "Ви впевнені, що хочете видалити об'єкт з ідентифікатором {{id}} з бази даних?",
      api_success_update: 'Дані успішно оновлено! {{text}}',
      api_success_create: "Об'єкт успішно створено!",
      api_success_send: 'Дані успішно надіслані!',
      api_success_refresh: 'Авторизація оновлена!',
      api_success_delete: "Об'єкт успішно видалено!",
      api_error: 'Помилка! {{text}}',
      file_contain_script: 'Файл містить скріпт!',
      file_unexpected_content: 'Файл містить неочікуваний вміст або скріпт!',
      unexpected_file_format: 'Непідтримуваний або неочікуваний формат файлу!',
      permission_denied: 'Доступ заборонено!',
      role_permission_denied: 'Адмінам заборонено призначати або змінювати роль Суперадміна',
      close: 'Закрити',
      api_error_title: 'API помилка',
      not_selected: '-',
      gallery: 'Галерея',
      tab: 'Основне',
      translations: 'Переклади',
      meta: 'Мета теги',
      text: 'Тексти',
      file_desc: 'Натисніть , щоб завантажити файл',
      translations_title: 'Редагувати переклади',
      male: 'Чоловік',
      female: 'Жінка',
      copied: 'Скопійовано!',
      yes: 'Так',
      no: 'Ні',
      download: 'Завантажити',
      slides: 'Слайди',
      add: 'Додати',
      copy: 'Копіювати',
      view_user_events: 'Переглянути події користувача',
      view_user_tests: 'Переглянути тести користувача',
      view_user_tenders: 'Переглянути тендери користувача',
      view_user_expert_consultation: 'Переглянути консультації експерта користувача',
      view_user_consultation_review: 'Переглянути відгуки консультацій користувача',
      view_user_education_review: 'Переглянути відгуки освіти користувача',
      view_user_expert_request: 'Переглянути запити експерта користувача',
      view_user_export_service_request: 'Переглянути запити послуг експорту користувача',
      view_user_consultation_quiz: 'Переглянути квізи консультацій користувача',
      view_user_entrepreneur_handbook: 'Переглянути довідники підприємця користувача',
      view_user_finance_service: 'Переглянути фінансові послуги користувача',
      view_expert_consultation: 'Переглянути консультації експерта',
      two_factor: 'Двофакторна автентифікація',
      two_factor_code: 'Верифікаційний код',
      scan_qr_code: '1. Відскануйте QR код в додатку (Google Authenticator)',
      fill_two_factor_code: '2. Введіть код з додатку/пошти',
      cache_cleared: 'Кеш очищено!',
      report: 'Звіт',
      logs: 'Логи',
    },
    fields: {
      id: 'ID',
      ID: 'ID',
      timezone: 'Часовий пояс',
      breadcrumb: 'Хлібна крихта',
      moduleId: 'Модуль',
      dayInterval: 'Інтервал днів',
      isExportServiceRequest: 'Використовувати в сервісах',
      exportServiceRequest: 'Запит на послугу',
      commentUpdatedAt: 'Дата оновлення коментаря',
      statusUpdatedAt: 'Дата оновлення статусу',
      point: 'Бал',
      is5GradeSystem: '5-бальна система',
      expectedSum: 'Очікувана сума',
      maxPoint: 'Максимальний бал',
      result: 'Результат',
      answers: 'Відповіді',
      testResult: 'Результат',
      usersRegistered: 'Кількість зареєстрованих',
      usersDone: 'Кількість завершивших',
      directionTypeId: 'Напрямок',
      isAdmin: 'Адміністратор',
      emails: 'Поштові адреси (через ,) (наприклад: test@test.com,test@test2.com)',
      regions: 'Регіони',
      websiteId: 'Вебсайт',
      menuPosition: 'Позиція меню',
      expertEmail: 'Пошта експерта',
      expertFullName: "Ім'я експерта",
      menuItem: 'Пункт меню',
      comment: 'Коментар',
      curator: 'Куратор',
      curatorComment: 'Коментар куратора',
      alt: 'Мета опис фото',
      inputType: 'Тип поля',
      googleId: 'Google ID',
      user_export_catalog_profile: 'Профіль каталогу',
      'entrepreneur-handbook': 'Довідник підприємця',
      isRead: 'Прочитано',
      entrepreneur_experience: 'Досвід підприємців',
      onCardOnly: 'На картці',
      annotations: 'Annotation (optional)',
      annotation: 'Анотація (опціонально)',
      isPopular: 'Популярні країни',
      kveds: 'КВЕДи',
      exportCountries: 'Країни, до яких вже експортуєте',
      importCountries: 'Країни, до яких вже імпортуєте',
      planeCountries: 'Країни цікаві для експорту',
      industries: 'Індустрії',
      organization_type: 'Тип організації',
      activity_type: 'Напрями діяльності',
      annual_turnover: 'Річний оборот',
      employees_number: 'Кількість працівників',
      enterprise_size: 'Розмір підприємства',
      ownership_type: 'Тип власності',
      loan_type: 'Тип кредиту',
      topic: 'Тип кредиту',
      form: 'Форма',
      export_trade_agreement: 'Тип угоди',
      organization_activity: 'Діяльність організації',
      export_region: 'Регіони експорту',
      export_locality: 'Місцевості експорту',
      export_product: 'Продукти експорту',
      expert_activity: 'Сфери',
      address: 'Адреса',
      schedule: 'Графік роботи',
      mappoint: 'Координати на мапі',
      isOrganic: 'Органічний',
      companyDescription: 'Опис команії',
      benefits: 'Конкретні переваги',
      companyAge: 'Вік компанії',
      productionCapacity: 'Виробнича потужність',
      sector: 'Сектор',
      sectors: 'Сектори',
      requestDate: 'Дата запиту',
      exportCountry: 'Країни, до яких вже експортує',
      importCountry: 'Країни, до яких вже експортує',
      planeCountry: 'Країни, цікаві для експорту',
      products: 'Продукти/сервіси',
      hsCode: 'HS код компанії',
      exportShare: 'Доля експорту у продажах, %',
      exportYear: 'Рік, з якого здійснюється системний експорт',
      isPlanExport: 'Чи планує експортувати',
      isExportAbroad: 'Чи експортує продукти чи послуги за кордон',
      importShare: 'Доля імпорту у продажах, %',
      importYear: 'Рік, з якого здійснюється системний імпорт',
      isPlanImport: 'Чи планує імпортувати',
      isImportAbroad: 'Чи імпортує продукти чи послуги за кордон',
      activityType: 'Тип діяльності',
      employeesNumber: 'Кількість працівників',
      annualTurnover: 'Річний оборот',
      establishmentYear: 'Рік заснування',
      isTaxpayer: 'Є платником податків',
      eudrpou: 'Реєстраційний код (ЄДРПОУ або ІПН)',
      firstName: 'Імʼя',
      lastName: 'Прізвище',
      middleName: 'По-батьковi',
      phones: 'Телефони',
      haveBusiness: 'Веде підтриємницьку діяльність',
      allowNotifications: 'Дає згоду на отримання поштової розсилки',
      firstConsultationCompleted: 'Первинна консультація пройдена',
      question: 'Запитання',
      answer: 'Відповідь',
      education: 'Освіта',
      course: 'Курс',
      isStart: 'Почав',
      isEnd: 'Завершив',
      minutes: 'Хвилин',
      doneTests: 'Виконано тестів',
      maxTests: 'Всього тестів',
      doneHomeworks: 'Виконано ДЗ',
      maxHomeworks: 'Всього ДЗ',
      exportService: 'Сервіс',
      researchUpdatedAt: 'Дата оновлення дослідження',
      surveyDateRange: 'Дата початку та кінця опитування',
      surveyStartDate: 'Дата початку опитування',
      surveyEndDate: 'Дата кінця опитування',
      authOnly: 'Файл доступно лише авторизованим користувачам',
      attributeName: 'Назва атрибуту',
      success_story_attribute: 'Історія успіху',
      proposal_attribute: 'Пропозиція',
      research_attribute: 'Дослідження',
      finance_service_attribute: 'Фінансовий сервіс',
      blog_attribute: 'Новина',
      event_attribute: 'Подія',
      education_attribute: 'Освіта',
      course_attribute: 'Курси',
      course_homework: 'Домашне завдання',
      countProgramsForCertificate: 'Кількість пройдених уроків для отримання сертифіката',
      entrepreneur_handbook_attribute: 'Довідник підприємця',
      center_attribute: 'Дія центр',
      initiative_attribute: 'Ініціатива',
      tender_attribute: 'Тендер',
      tools_attribute: 'Інструмент',
      export_handbook_article_attribute: 'Довідник експортера',
      export_handbook_link_theme_attribute: 'Тема посилань довідника експортера',
      email: 'Електронна пошта',
      instLink: 'Посилання на Instagram',
      fbLink: 'Посилання на Facebook',
      inLink: 'Посилання на LinkedIn',
      selectImage: 'Зображення',
      finance_service: 'Фінансування',
      initiative: 'Ініціатива',
      companyName: 'Назва компанії',
      filter: 'Назва фільтру',
      finance_filter: 'Фільтр',
      finance_attribute: 'Атрибут',
      content_category: 'Категорія контенту',
      show_main: 'Відображати на головній',
      created: 'Створено',
      updated: 'Оновлено',
      status: 'Статус',
      role: 'Роль',
      roles: 'Ролі',
      password: 'Пароль',
      password_confirm: 'Підтвердження пароля',
      name: 'Назва',
      description: 'Опис',
      value: 'Значення',
      type: 'Тип',
      btnType: 'Тип кнопки',
      discountRange: 'Діапазон знижки',
      img: 'Зображення',
      partner_logo: 'Лого партнера',
      size: 'Розмір',
      code: 'Код',
      active: 'Активний',
      isIdea: 'Відображати ідею',
      isProposal: 'Відображати пропозицію',
      order: 'Порядок',
      logo: 'Логотип',
      title: 'Заголовок',
      slug: 'ЛЗУ',
      finance_programs: 'Фінансові програми',
      educations: 'Навчання',
      courses: 'Курси',
      supporters: 'Підтримка',
      component_headers: 'Картки в заголовку',
      component_components: 'Картки в компонентках',
      component_advantages: 'Картки в перевагах',
      component_others: 'Картки в інше',
      alias: 'Аліас',
      language: 'Мова',
      isActive: 'Відображати',
      level1: 'Перший рівень',
      level2: 'Другий рівень',
      level3: 'Третій рівень',
      level4: 'Четвертий рівень',
      levelAdd: 'Додатковий рівень',
      entrepreneurType: 'Тип підприємція',
      fullName: 'ПІБ',
      feedbackCategory: 'Категорія',
      enterpriseSize: 'Розмір підприємства',
      partnershipReqDescr: 'Опис пропозиції про партнерство',
      partnershipBenefits: 'Переваги партнерства',
      partnershipArea: 'Можливі сфери партнерства',
      partnership: 'Партнерство з проєктом',
      partnership_contact_person: 'Контактна особа',
      view_type: 'Тип відображення',
      promocode: 'Промокод',
      actionEndDate: 'Срок дії акції',
      success_story: 'Історії успіху',
      success_story_category: 'Категорія',
      success_story_authors: 'Автори',
      tender: 'Тендери',
      startDate: 'Дата початку',
      endDate: 'Дедлайн',
      amount: 'Вартість',
      assistanceType: 'Вид допомоги',
      validityPeriod: 'Срок дії акції',
      productDescription: 'Короткий опис вашого продукту',
      presentationLink: 'Посилання на презентаційні матеріали',
      managerFullName: 'ПІБ менеджера',
      managerPhone: 'Мобільний телефон менеджера',
      managerEmail: 'Email менеджера',
      kved: 'КВЕД',
      message: 'Зміст заявки',
      region: 'Область',
      city: 'Місто',
      createdAt: 'Дата',
      uid: 'Унікальний ідентифікатор',
      feedbackStatus: 'Статус',
      taxGroup: 'Група оподаткування',
      ownershipType: 'Форма власності',
      settlement: 'Населений пункт',
      stateAuthority: 'Державний орган',
      criticalityLevel: 'Рівень критичності ситуації',
      feedbackKveds: 'КВЕДи ',
      rnokpp: 'Реєстраційний код (РНОКПП/ЄДРПОУ)',
      legalEntityName: 'Найменування юридичної особи',
      street: 'Вулиця',
      house: 'Будинок',
      apartmentNumber: 'Номер квартири/офісу',
      postcode: 'Індекс',
      gender: 'Стать',
      jobTitle: 'Посада',
      companyEmail: 'Електронна адреса підприємства',
      phone: 'Телефон',
      website: 'Сайт',
      homework: 'Домашне завдання',
      companyPhone: 'Номер телефону підприємства',
      stateAuthorityFullName: 'ПІБ посадової особи органу державної влади',
      stateAuthorityJobTitle: 'Посада посадової особи органу державної влади',
      measures: 'Заходи, яких було вжито для вирішення проблеми',
      documentDesc: 'Опис документів',
      useOmbudsman: 'Потрібно підключити до розгляду Раду Бізнес-Омбудсмена',
      feedbackKvedFirst: 'Основний КВЕД',
      feedbackKved: 'Додатковий КВЕД',
      feedbackType: 'Варіант',
      url: 'Посилання',
      opinionResolve: 'Що може зробити Рада Бізнес-Омбудсмена для вирішення ситуації',
      blog_category: 'Тема',
      expert: 'Експерт',
      youtube: 'YouTube',
      facebook: 'Facebook',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      publishedAt: 'Дата публікації',
      establishedAt: 'Дата заснування',
      government: 'Урядова інформація',
      department: 'Офіс',
      country: 'Країна',
      countries: 'Країни',
      industry: 'Індустрія',
      'export-product': 'Продукт',
      finance_type: 'Тип',
      finance_category: 'Категорія',
      business_category: 'Катеорія бізнесу',
      currency: 'Валюта',
      finance_amount: 'Сума',
      finance_class: 'Вид фінансування',
      finance_institution: 'Фінансова інституція',
      finance_product: 'Фінансовий продукт',
      finance_provision: 'Забезпечення',
      finance_rate: 'Ставка',
      finance_term: 'Строк',
      image: 'Зображення',
      externalLink: 'Посилання',
      location: 'Локація',
      consultation: 'Консультація',
      date: 'Дата',
      online: 'Онлайн',
      offline: 'Офлайн',
      consultationAddress: 'Адреса для консультацій',
      consultationDate: 'Дата консультації',
      onlineOrOffline: 'Тип звʼязку',
      show_quiz: 'Показувати в квізах',
      category: 'Категорія',
      user: 'Користувач',
      consultations: 'Консультації',
      resume: 'Резюме',
      theme: 'Напрямок',
      isOnline: 'Онлайн',
      isOffline: 'Офлайн',
      speaker: 'Спікер',
      grade: 'Оцінка',
      survey: 'Опитування',
      day: 'День',
      services: 'Послуги',
      registrationType: 'Тип реєстрації',
      registrationLink: 'Посилання на реєстрацію',
      startAt: 'Початок',
      endAt: 'Закінчення',
      hs_code: 'HS',
      additional: 'Додатково',
      test: 'Тест',
      firstConsultationRequired: "Первинна консультація обов'язкова",
      quizRequired: "Квіз обов'язковий",
      showResultQuiz: 'Відображати в результатах квіза',
      showResultQuizExport: 'Відображати в результатах квіза Екпорту',
      showResultQuizFinance: 'Відображати в результатах квіза Фінансах',
      link: 'Посилання',
      buttonType: 'Тип кнопки',
      certificate: 'Сертифікат',
      userCourse: 'Курс користувача',
      file: 'Файл',
      protected_pdf_file: 'Захищений PDF файл',
      edrpou: 'ЕДРПОУ',
      uktzed: 'УКТЗЕД',
      uktzeds: 'Коди УКТЗЕД',
      export: 'Експорт',
      import: 'Імпорт',
      event: 'Подія',
      companyWorkers: 'Працівників',
      useAtFinance: 'Відображати в фінансах',
      hideChat: 'Приховати чат',
      useAtEducation: 'Відображати в освіті',
      isAutoApprove: 'Авто апрув',
      testRequired: "Тест обов'язковий",
      uktzedTestRequired: "Перевірка УКТЗЕД обов'язкова",
      helpdesk: 'Хелпдеск',
      channel: 'Канал',
      organizer: 'Організатор',
      format: 'Формат',
      regEndAt: 'Дата завершення реєстрації',
      moduleName: 'Назва модулю',
      read: 'Перегляд',
      hasNavbar: 'Має навігацію',
      write: 'Запис',
      delete: 'Видалення',
      show: 'Меню',
      gradient: 'Градієнт',
      subject: 'Тема',
      teacher: 'Вчитель',
      student: 'Учень',
      from: 'Відправник',
      template: 'Шаблон',
      attrName: 'Назва (EN camelCase), наприклад: testAttr',
      page: 'Сторінка',
      position: 'Тип відображення',
      video: 'Відео',
      userEmail: 'Email користувача',
      user_profile_filter: 'Фільтр',
      userId: 'ID користувача',
      entity: 'Сутність',
      action: 'Дія',
      ip: 'IP',
      deliveryMethod: 'Метод отримання 2FA кодів',
      event_type: 'Тип події',
      country_group: 'Група країн',
      toolName: 'Назва інструменту',
    },
    constants: {
      dash: '—',
      user_status: {
        step1: 'Крок 1',
        step2: 'Крок 2',
        step3: 'Крок 3',
        step4: 'Крок 4',
        active: 'Активний',
        blocked: 'Заблоковано',
      },
      'export-import': {
        export: 'Експорт',
        import: 'Імпорт',
        none: '-',
      },
      export_trade_agreement: {
        default: 'За замовчуванням',
        trade: 'Торгівля',
        limit: 'Ліміт',
      },
      page_partner: {
        left: 'Зліва',
        right: 'Справа',
      },
      website: {
        main: 'Основний',
        international: 'Інтернаціональний',
        both: 'Всі',
      },
      timezone: {
        baker_island: 'Острів Бейкер (Тихий океан/Мідуей)',
        honolulu: 'Гонолулу (Тихий океан/Гонолулу)',
        anchorage: 'Анкоридж (Америка/Анкоридж)',
        los_angeles: 'Лос-Анджелес (Америка/Лос-Анджелес)',
        vancouver: 'Ванкувер (Америка/Ванкувер)',
        mexico_city: 'Мехіко (Америка/Мехіко)',
        chicago: 'Чикаго (Америка/Чикаго)',
        new_york: 'Нью-Йорк (Америка/Нью-Йорк)',
        buenos_aires: 'Буенос-Айрес (Америка/Аргентина/Буенос-Айрес)',
        brasilia: 'Бразилія (Америка/Сан-Паулу)',
        london: 'Лондон (Європа/Лондон)',
        utc: 'UTC',
        berlin: 'Берлін (Європа/Берлін)',
        paris: 'Париж (Європа/Париж)',
        cairo: 'Каїр (Африка/Каїр)',
        kyiv: 'Київ (Європа/Київ)',
        istanbul: 'Стамбул (Європа/Стамбул)',
        moscow: 'Москва (Європа/Москва)',
        tehran: 'Тегеран (Азія/Тегеран)',
        dubai: 'Дубай (Азія/Дубай)',
        delhi: 'Делі (Азія/Калькутта)',
        jakarta: 'Джакарта (Азія/Джакарта)',
        bangkok: 'Бангкок (Азія/Бангкок)',
        shanghai: 'Шанхай (Азія/Шанхай)',
        singapore: 'Сінгапур (Азія/Сінгапур)',
        hong_kong: 'Гонконг (Азія/Гонконг)',
        seoul: 'Сеул (Азія/Сеул)',
        tokyo: 'Токіо (Азія/Токіо)',
        sydney: 'Сідней (Австралія/Сідней)',
        auckland: 'Окленд (Тихий океан/Окленд)',
      },
      menuPosition: {
        header: 'Хедер',
        footer: 'Футер',
      },
      blog_status: {
        hide: 'Прихований',
        active: 'Активний',
      },
      finance_status: {
        hide: 'Чернетка',
        active: 'Активний',
        review: 'На перевірці',
        rejected: 'Відхилено',
        completed: 'Завершено',
      },
      input_type: {
        text: 'Текстове значення',
        number: 'Числове значення',
        date: 'Дата',
      },
      search_popular_request_status: {
        hide: 'Прихований',
        active: 'Активний',
      },
      success_story_status: {
        hide: 'Прихований',
        active: 'Активний',
      },
      export_brand_file: {
        hide: 'Прихований',
        active: 'Активний',
      },
      partnership_types: {
        learn_more: 'Дізнатися більше',
        send_request: 'Надіслати запит',
        login_required: 'Увійти до кабінету',
      },
      partnership_request_status: {
        moderation: 'Модерація',
        done: 'Переглянуто',
      },
      success_story: {
        default: 'Стандартний',
        expanded: 'Розширений',
      },
      success_story_types: {
        story: 'Історії підприємців',
        advice: 'Поради підприємцям',
      },
      blog_post: {
        default: 'Стандартний',
        special_project: 'Спецпроєкт',
      },
      research_request_status: {
        moderation: 'Модерація',
        done: 'Переглянуто',
      },
      proposal_discount_range: {
        free: 'Безкоштовно',
        from0to20: '0-20',
        from20to40: '20-40',
        from40to60: '40-60',
        from60to80: '60-80',
        from80to100: '80-100',
      },
      tender_request_status: {
        moderation: 'Модерація',
        done: 'Переглянуто',
      },
      tender_type: {
        tender: 'Тендер',
        proposal: 'Пропозиція',
      },
      user_roles: {
        admin: 'Адміністратор',
        entrepreneur: 'підприємець',
        consultant: 'Консультант',
        marketplace: 'Маркетплейс',
        EKA: 'ЕКА',
        expert: 'Експерт',
        businessAssociation: 'Бізнес асоціація',
        superadmin: 'Суперадмін',
        lmsAdmin: 'LMS',
      },
      export_request_type: {
        question: 'Питання',
        request: 'Запит',
      },
      export_request_status: {
        moderation: 'Модерація',
        done: 'Переглянуто',
        cancel: 'Скасовано',
      },
      setting: {
        str: 'Текст',
        num: 'Число',
        bool: 'Логічне значення',
      },
      partner: {
        initiator: 'Ініціатор',
        support: 'Підтримка',
        coordinator: 'Координатор',
      },
      blog_proposal_status: {
        new: 'Новий',
        moderate: 'Пройшов модерацію',
      },
      expert_type: {
        expert: 'Експерт',
        consultant: 'Консультант',
        expert_consultant: 'Експерт/Консультант',
      },
      expert_status: {
        moderation: 'Модерація',
        show: 'Активний',
        hide: 'Прихований',
      },
      question_status: {
        new: 'Нове',
        read: 'Прочитано',
      },
      consultation_status: {
        none: '-',
        active: 'Активний',
        hide: 'Прихований',
        system: 'Системний',
      },
      consultant_request_status: {
        moderation: 'Модерація',
        done: 'Переглянуто',
      },
      is_taxpayer: {
        true: 'Так',
        false: 'Ні',
        none: '-',
      },
      is_boolean_select: {
        true: 'Так',
        false: 'Ні',
        none: '-',
      },
      expert_question_status: {
        moderation: 'Модерація',
        done: 'Переглянуто',
      },
      event_registration_type: {
        link: 'Посилання',
        form: 'Форма',
        formLink: 'Форма + Посилання',
      },
      event_type: {
        default: 'Стандартний',
        lms: 'ЛМС',
      },
      event_format_type: {
        online: 'Онлайн',
        offline: 'Офлайн',
      },
      expert_review_status: {
        moderation: 'Модерація',
        show: 'Видимий',
      },
      expert_consultation_status: {
        new: 'Новий',
        moderation: 'Модерація',
        cancel: 'Скасовано',
        done: 'Підтверджено',
      },
      expert_request_status: {
        moderation: 'Модерація',
        done: 'Переглянуто',
      },
      expert_request_type: {
        request: 'Запит',
        become: 'Стати',
        invite: 'Запросити',
      },
      education_review_status: {
        moderation: 'Модерація',
        show: 'Видимий',
      },
      education_registration_status: {
        moderation: 'Модерація',
        approve: 'Затверджено',
        cancel: 'Відхилено',
      },
      course_review_status: {
        moderation: 'Модерація',
        show: 'Видимий',
      },
      consultation_review_status: {
        moderation: 'Модерація',
        show: 'Видимий',
      },
      event_status: {
        hide: 'Прихований',
        reg_active: 'Реєстрація відкрита',
        reg_complete: 'Реєстрація завершується',
        reg_done: 'Реєстрація завершена',
      },
      user_event_registration: {
        moderation: 'Модерація',
        cancel: 'Відхилено',
        done: 'Прийнято',
        register: 'Зареєстровано',
      },
      user_education: {
        active: 'Активний',
        cancel: 'Відхилено',
        completed: 'Завершено',
      },
      idea_status: {
        active: 'Активний',
        hide: 'Прихований',
      },
      test_result_type: {
        success: 'Здано',
        fail: 'Не здано',
      },
      test_parent_type: {
        none: 'Немає',
        export: 'Експорт',
        education: 'Освіта',
      },
      user_export_catalog_profile: {
        moderate: 'На модерації',
        approved: 'Прийнято',
        declined: 'Відхилено',
      },
      user_import_catalog_profile: {
        moderate: 'На модерації',
        approved: 'Прийнято',
        declined: 'Відхилено',
      },
      education_status: {
        hide: 'Приховано',
        reg_active: 'Заплановані',
        reg_complete: 'Завершена',
      },
      education_button_type: {
        none: 'Немає',
        anchor: 'Якір',
        internal_link: 'Внутрішне посилання',
        external_link: 'Зовнішне посилання',
        feedback_form: 'Зворотня форма',
        file: 'Файл',
        start: 'Розпочати',
        register: 'Форма реєстрації',
      },
      education_partner_type: {
        main: 'Партнери',
        in: 'У партнерстві',
        support: 'За підтримки',
      },
      education_type: {
        internal: 'Внутрішне',
        external: 'Зовнішне',
      },
      education_format_type: {
        online: 'Онлайн',
        offline: 'Офлайн',
      },
      course_status: {
        hide: 'Приховано',
        reg_active: 'Заплановані',
        reg_complete: 'Завершена',
      },
      user_course_status: {
        moderation: 'Модерація',
        active: 'Активна',
        cancel: 'Відмінена',
        completed: 'Завершена',
      },
      user_course_homework_status: {
        moderation: 'Модерація',
        cancel: 'Відмінена',
        rework: 'На переробку',
        completed: 'Виконана',
      },
      course_button_type: {
        none: 'Немає',
        start: 'Розпочати',
        register: 'Форма реєстрації',
      },
      course_test_type: {
        test: 'Тест',
        poll: 'Опитування',
        none: '-',
      },
      course_partner_type: {
        main: 'Партнери',
        in: 'У партнерстві',
        support: 'За підтримки',
      },
      course_type: {
        default: 'Постійний',
        long: 'Довготривалий',
      },
      course_format_type: {
        online: 'Онлайн',
        offline: 'Офлайн',
      },
      export_service_request_status: {
        moderation: 'Нове',
        cancel: 'Відхилено',
        done: 'Надано',
        inProgress: 'Надається',
      },
      export_service_request_type: {
        question: 'Запитання',
        request: 'Запит',
      },
      export_service_type: {
        EKA: 'EKA',
        TPP: 'TPP',
        company: 'Компанії',
        alliance: 'Альянси',
      },
      export_team_type: {
        office: 'Офіс',
        digital: 'Міністерство цифрової трансформації',
        economy: 'Міністерство економіки',
      },
      module: {
        no: 'Немає',
        all: 'Всі',
        blog: 'Блог',
        event: 'Події',
        education: 'Освіта (Education)',
        consultation: 'Консультація',
        partnership: 'Партнерство',
        success: 'Історії успіху',
        analytics: 'Аналітика',
        initiative: 'Ініціатива',
        center: 'Дія центр',
        finance: 'Фінанси',
        entrepreneur: 'Довідник підприємця',
        exporter: 'Довідник експортера',
        educationLMS: 'Освіта (LMS)',
      },
      test_question_type: {
        select: 'Cелект',
        radio: 'Радіо',
        text: 'Текст',
        multiselect: 'Мультиселект',
      },
      course_test_question_type: {
        select: 'Cелект',
        radio: 'Радіо',
        text: 'Текст',
      },
      tools_service_type: {
        internal: 'Внутрішне',
        external: 'Зовнішне',
      },
      import_service_request_status: {
        moderation: 'Модерація',
        cancel: 'Відміна',
        done: 'Закрито',
      },
      import_service_type: {
        office: 'Офіс',
        EKAInsurance: 'EKA страхування',
        EKACredit: 'EKA кредіт',
      },
      gender: {
        male: 'Чоловіча',
        female: 'Жіноча',
      },
      finance_role_request_status: {
        new: 'Новий',
        accepted: 'Прийнято',
        declined: 'Відхилено',
      },
      log_action: {
        create: 'Створено сутність',
        update: 'Оновлено сутність',
        delete: 'Видалено сутність',
      },
      two_factor_delivery_method: {
        email: 'Пошта',
        authenticator: 'Автентифікатор',
      },
      analytic_report_status: {
        queued: 'В черзі',
        processing: 'Обробляється',
        completed: 'Виконано',
        failed: 'Невдалий',
      },
    },
    errors: {
      invalid: 'Невірний формат',
      email: 'Невірний формат',
      pattern: 'Невірний формат',
      'auth.invalid_credential': 'Невірний пароль',
      required: "Обов'язкове поле",
      invalidHsCode: 'Неправильний код УКТЗЕД',
    },
    user: {
      tab: {
        security: 'Безпека',
        permission: 'Дозвіл',
        profile: 'Особисті дані',
        enterprise: 'Інформація про підприємство',
        export: 'Інформація про експорт',
        import: 'Інформація про імпорт',
        topics: 'Обрані теми',
        employee: 'Співробітники',
        history: 'Історія користувача',
        two_factor: '2FA',
      },
      create_title: 'Новий користувач',
      edit_title: 'Редагувати користувача',
      tab_show: 'Користувач',
      title: 'Користувачі',
      export_catalog_profile: 'Профіль для каталогу експортерів',
      import_catalog_profile: 'Профіль для каталогу імпортерів',
      enterprise_profile: 'Профіль компанії',
      export_profile: 'Профіль експортера',
      import_profile: 'Профіль імпортера',
    },
    setting: {
      title: 'Налаштування',
      create_title: 'Нове налаштування',
      edit_title: 'Редагувати налаштування',
    },
    language: {
      create_title: 'Нова мова',
      edit_title: 'Редагувати мову',
      title: 'Мови',
    },
    page: {
      create_title: 'Нова сторінка',
      edit_title: 'Редагувати сторінку',
      title: 'Сторінки',
    },
    katottg: {
      create_title: 'Новий об’єкт',
      edit_title: 'Редагувати об’єкт',
      title: 'Об’єкти',
    },
    partner: {
      create_title: 'Новий партнер',
      edit_title: 'Редагувати партнера',
      title: 'Партнер',
    },
    blog_category: {
      create_title: 'Нова категорія',
      edit_title: 'Редагувати категорію',
      title: 'Категорії новин',
    },
    blog_post: {
      create_title: 'Нова новина',
      edit_title: 'Редагувати новину',
      title: 'Новини',
      partners: 'Партнери',
    },
    analytic_dashboard: {
      create_title: 'Новий дашбоард',
      edit_title: 'Редагувати дашбоард',
      title: 'Дашбоарди',
    },
    analytic_question: {
      create_title: 'Нове запитання',
      edit_title: 'Редагувати запитання',
      title: 'Часті запитання',
    },
    analytic_addition: {
      create_title: 'Нове додаткове',
      edit_title: 'Редагувати додаткове',
      title: 'Додаткове',
    },
    analytic_report: {
      create_title: 'Новий звіт',
      edit_title: 'Редагувати звіт',
      title: 'Звіти',
    },
    export_tool: {
      sections: {
        demographic: {
          label: 'Демографія',
        },
        economic: {
          label: 'Економічні показники',
        },
        tradeIndicators: {
          label: 'Торговельні індикатори',
        },
        tariffRatesAndMarketDistance: {
          label: 'Тарифи та відстань до ринку',
        },
        marketDemand: {
          label: 'Оцінка попиту (споживання)',
        },
        inflation: {
          label: 'Інфляція',
        },
      },
      labels: {
        population: 'Населення в поточному році',
        populationGrowth: 'Динаміка зростання населення',
        predictedPopulation3Years: 'Кількість населення через 3 роки',
        predictedPopulation5Years: 'Кількість населення через 5 років',
        gdp: 'ВВП країни',
        gdpGrowth: 'Динаміка зростання ВВП',
        predictedGdp3Years: 'Прогноз ВВП за 3 роки',
        predictedGdp5Years: 'Прогноз ВВП за 5 років',
        gdpPerCapita: 'ВВП на душу населення',
        importedValue: 'Обсяги імпорту',
        cagrImportedValue: 'Динаміка імпорту',
        predictedImportValue3Years: 'Прогноз імпорту через 3 роки',
        predictedImportValue5Years: 'Прогноз імпорту через 5 років',
        tradeBalance: 'Торгівельний баланс',
        valueExported: 'Обсяги українського експорту',
        concentrationSupplyingCountries: 'І́ндекс концентрації',
        tariffRate: 'Тарифна різниця',
        marketDistance: 'Відстань до країни',
        marketSize: 'Розмір ринку',
        importPricePerTon: 'Вартість за тонну',
        currencyDynamic5Years: 'Інфляція',
        currencyDynamic1Year: 'Прогноз інфляції',
      },
    },
    research: {
      create_title: 'Нове дослідження',
      edit_title: 'Редагувати дослідження',
      title: 'Дослідження',
    },
    country_group: {
      create_title: 'Нова група країн',
      edit_title: 'Редагувати групу країн',
      title: 'Групи країн',
    },
    research_type: {
      create_title: 'Новий тип',
      edit_title: 'Редагувати тип',
      title: 'Типи досліджень',
    },
    research_request: {
      create_title: 'Нове замовлення',
      edit_title: 'Редагувати замовлення',
      title: 'Замовлення досліджень',
    },
    robots: {
      edit_title: 'Редагувати robots.txt',
      title: 'Robots.txt',
    },
    partnership: {
      create_title: 'Нове партнерство з проєктом',
      edit_title: 'Редагувати партнерство з проєктом',
      title: 'Партнерство з проєктом',
    },
    partnership_contact_person: {
      create_title: 'Нова контактна особа',
      edit_title: 'Редагувати контактну особу',
      title: 'Контактні особи',
    },
    partnership_request: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити на партнерство з проєктом',
    },
    partnership_area: {
      create_title: 'Нова сфера партнерства',
      edit_title: 'Редагувати сферу партнерства',
      title: 'Можливі сфери партнерства',
    },
    search_popular_request: {
      create_title: 'Новий популярний запит',
      edit_title: 'Редагувати популярний запит',
      title: 'Популярні запити',
    },
    success_story: {
      create_title: 'Нова історія успіху',
      edit_title: 'Редагувати історію успіху',
      title: 'Історії успіху',
    },
    success_story_category: {
      create_title: 'Нова категорія',
      edit_title: 'Редагувати категорію',
      title: 'Категорії',
    },
    success_story_author: {
      create_title: 'Новий автор',
      edit_title: 'Редагувати автора',
      title: 'Автори історій',
    },
    proposal: {
      title: 'Пропозиції',
      create_title: 'Нова пропозиція',
      edit_title: 'Редагувати пропозицію',
    },
    proposal_assistance_type: {
      title: 'Види допомоги',
      create_title: 'Новий вид допомоги',
      edit_title: 'Редагувати вид допомоги',
    },
    proposal_question: {
      title: 'Запитання',
      create_title: 'Створити запитання',
      edit_title: 'Редагувати запитання',
    },
    tender: {
      create_title: 'Новий тендер',
      edit_title: 'Редагувати тендер',
      title: 'Тендери',
      properties: 'Параметри',
      edit_properties: 'Редагувати параметри',
    },
    tender_request: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити',
    },
    tender_question: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити',
    },
    initiative: {
      create_title: 'Нова ініціатива',
      edit_title: 'Редагувати ініціативу',
      title: 'Ініціативи',
    },
    menu_item: {
      create_title: 'Новий пункт меню',
      edit_title: 'Редагувати пункт меню',
      title: 'Пункти меню',
    },
    menu: {
      create_title: 'Нове меню',
      edit_title: 'Редагувати меню',
      title: 'Меню',
    },
    initiative_question: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити до ініціатив',
    },
    center: {
      create_title: 'Новий Дія центр',
      edit_title: 'Редагувати Дія центр',
      title: 'Дія центри',
    },
    service: {
      create_title: 'Нова послуга',
      edit_title: 'Редагувати послугу',
      title: 'Послуги',
    },
    center_question: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити щодо Дія центрів',
    },
    main_question: {
      title: 'Запити',
      edit_title: 'Редагувати запит',
    },
    main_content_category: {
      title: 'Категорії контенту',
      edit_title: 'Редагувати категорію контенту',
      create_title: 'Нова категорія контенту',
    },
    finance_program: {
      create_title: 'Нова фінансова програма',
      edit_title: 'Редагувати фінансову програму',
      title: 'Фінансові програми',
    },
    finance_service: {
      create_title: 'Нове фінансування',
      edit_title: 'Редагувати фінансування',
      title: 'Фінансування',
    },
    finance_category: {
      create_title: 'Нова категорія фінансів',
      edit_title: 'Редагувати категорію фінансів',
      title: 'Категорії фінансів',
    },
    finance_handbook_category: {
      create_title: 'Нова категорія довідників фінансів',
      edit_title: 'Редагувати категорію довідників фінансів',
      title: 'Категорії довідників фінансів',
    },
    finance_handbook: {
      create_title: 'Новий довідник фінансів',
      edit_title: 'Редагувати довідник фінансів',
      title: 'Довідники фінансів',
    },
    finance_role_request: {
      edit_title: 'Запит на роль Маркетплейс',
      title: 'Запити на роль Маркетплейс',
    },
    finance_question: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити до фінансових установ',
    },
    finance_type: {
      create_title: 'Новий тип фінансів',
      edit_title: 'Редагувати тип фінансів',
      title: 'Типи фінансів',
    },
    finance_filter: {
      create_title: 'Новий фільтр',
      edit_title: 'Редагувати фільтр',
      title: 'Фільтри фінансів',
    },
    finance_attribute: {
      create_title: 'Новий атрибут',
      edit_title: 'Редагувати атрибут',
      title: 'Атрибути фінансів',
    },
    finance_service_attribute: {
      create_title: 'Новий атрибут',
      edit_title: 'Редагувати атрибут',
      title: 'Атрибути фінансів',
    },
    business_category: {
      create_title: 'Нова категорія бізнесу',
      edit_title: 'Редагувати категорію бізнесу',
      title: 'Категорії бізнесу',
    },
    user_test: {
      title: 'Тести користувача',
      edit_title: 'Редагувати тест користувача',
    },
    currency: {
      create_title: 'Нова валюта',
      edit_title: 'Редагувати валюту',
      title: 'Валюти',
    },
    loan_type: {
      create_title: 'Новий тип кредиту',
      edit_title: 'Редагувати тип кредиту',
      title: 'Типи кредитів',
    },
    finance_amount: {
      create_title: 'Нова сумма',
      edit_title: 'Редагувати сумму',
      title: 'Сумми',
    },
    finance_class: {
      create_title: 'Новий вид фінансування',
      edit_title: 'Редагувати вид фінансування',
      title: 'Види фінансування',
    },
    finance_institution: {
      create_title: 'Нова фінансова інституція',
      edit_title: 'Редагувати фінансову інституцію',
      title: 'Фінансові інституції',
    },
    finance_product: {
      create_title: 'Новий фінансовий продукт',
      edit_title: 'Редагувати фінансовий продукт',
      title: 'Фінансові продукти',
    },
    finance_provision: {
      create_title: 'Нове забезпечення',
      edit_title: 'Редагувати забезпечення',
      title: 'Забезпечення',
    },
    finance_rate: {
      create_title: 'Нова ставка',
      edit_title: 'Редагувати ставку',
      title: 'Ставки',
    },
    finance_term: {
      create_title: 'Новий строк',
      edit_title: 'Редагувати строк',
      title: 'Строки',
    },
    experts: {
      create_title: 'Новий експерт',
      edit_title: 'Редагувати експерта',
      title: 'Експерти',
      schedule: 'Черга',
      certificates: 'Сертифікати',
    },
    expert_request: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити',
    },
    page_partner: {
      create_title: 'Новий партнер',
      edit_title: 'Редагувати партнера',
      title: 'Партнери',
    },
    government: {
      create_title: 'Нова урядова інформація',
      edit_title: 'Редагувати урядову інформацію',
      title: 'Урядові інформації',
    },
    supporter: {
      create_title: 'Нова інформація про підтримку',
      edit_title: 'Редагувати інофрмацію про підтримку',
      title: 'Інформація про підтримку',
    },
    component: {
      create_title: 'Нова інформація про картки',
      edit_title: 'Редагувати інформацію про картку',
      title: 'Інформація про картку',
    },
    department: {
      create_title: 'Новий офіс',
      edit_title: 'Редагувати офіс',
      title: 'Офіси',
    },
    country: {
      create_title: 'Нова країна',
      edit_title: 'Редагувати країну',
      title: 'Країни',
      industry_tab: 'Індустрії',
      request_tab: 'Запити на партнерство',
      country_info: 'Загальна інформація',
      country_export_requirement: 'Вимоги до продукції',
      country_import_requirement: 'Роздрібні мережі',
    },
    industry: {
      create_title: 'Нова індустрія',
      edit_title: 'Редагувати індустрію',
      title: 'Індустрії',
    },
    'export-product': {
      create_title: 'Новий продукт',
      edit_title: 'Редагувати продукт',
      title: 'Продукт',
    },
    country_info: {
      create_title: 'Створити інформацію про країну',
      edit_title: 'Редагувати інформацію про країну',
      title: 'Загальна інформація про країни',
    },
    country_export_requirement: {
      create_title: 'Вимоги до продукції',
      edit_title: 'Редагувати вимоги до продукції',
      title: 'Вимоги до продукції країн',
    },
    country_import_requirement: {
      create_title: 'Роздрібні мережі',
      edit_title: 'Редагувати роздрібні мережі',
      title: 'Вимоги до роздрібних мереж',
    },
    blog_post_proposal: {
      edit_title: 'Редагувати пропозицію',
      title: 'Пропозиції',
    },
    expert_theme: {
      title: 'Теми',
      edit_title: 'Редагувати тему',
      create_title: 'Створити тему',
    },
    organization_type: {
      title: 'Типи організацій',
      edit_title: 'Редагувати тип організації',
      create_title: 'Створити тип організації',
    },
    activity_type: {
      title: 'Напрями діяльності',
      edit_title: 'Редагувати напрям діяльності',
      create_title: 'Створити напрям діяльності',
    },
    annual_turnover: {
      title: 'Річний оборот',
      edit_title: 'Редагувати річний оборот',
      create_title: 'Створити річний оборот',
    },
    employees_number: {
      title: 'Кількість працівників',
      edit_title: 'Редагувати кількість працівників',
      create_title: 'Створити кількість працівників',
    },
    enterprise_size: {
      title: 'Розмір підприємства',
      edit_title: 'Редагувати розмір підприємства',
      create_title: 'Створити розмір підприємства',
    },
    kved: {
      title: 'КВЕДи',
      edit_title: 'Редагувати КВЕД',
      create_title: 'Створити КВЕД',
    },
    ownership_type: {
      title: 'Типи власності',
      edit_title: 'Редагувати тип власності',
      create_title: 'Створити тип власності',
    },
    topic: {
      title: 'Теми',
      edit_title: 'Редагувати тему',
      create_title: 'Створити тему',
    },
    organization_activity: {
      title: 'Діяльність організацій',
      edit_title: 'Редагувати діяльність організації',
      create_title: 'Створити діяльність організації',
    },
    export_region: {
      title: 'Регіони експорту',
      edit_title: 'Редагувати регіон експорту',
      create_title: 'Створити регіон експорту',
    },
    export_locality: {
      title: 'Місцевості експорту',
      edit_title: 'Редагувати місцевість експорту',
      create_title: 'Створити місцевість експорту',
    },
    export_product: {
      title: 'Продукти експорту',
      edit_title: 'Редагувати продукт експорту',
      create_title: 'Створити продукт експорту',
    },
    entrepreneur_handbook_category: {
      title: 'Категорії довідників підприємця',
      edit_title: 'Редагувати Категорію',
      create_title: 'Створити Категорію',
    },
    entrepreneur_handbook_type: {
      title: 'Типи довідників підприємця',
      edit_title: 'Редагувати тип',
      create_title: 'Створити тип',
    },
    'export_handbook_article-type': {
      title: 'Типи довідників експортера',
      edit_title: 'Редагувати тип',
      create_title: 'Створити тип',
    },
    export_handbook_article: {
      title: 'Довідники експортера',
      edit_title: 'Редагувати Довідник',
      create_title: 'Створити Довідник',
    },
    export_handbook_category: {
      title: 'Категорії довідників експортера',
      edit_title: 'Редагувати Категорію',
      create_title: 'Створити Категорію',
    },
    export_handbook_link: {
      title: 'Корисні посилання довідників експортера',
      edit_title: 'Редагувати посилання',
      create_title: 'Створити посилання',
    },
    'export-handbook-link-theme': {
      title: 'Теми корисних посилання довідників експортера',
      edit_title: 'Редагувати теми посилання',
      create_title: 'Створити теми посилання',
    },
    export_request: {
      create_title: 'Новий запит',
      edit_title: 'Редагувати запит',
      title: 'Запити',
    },
    export_bank: {
      create_title: 'Новий банк',
      edit_title: 'Редагувати банк',
      title: 'Банки',
    },
    export_helpdesk: {
      create_title: 'Новий хелпдеск',
      edit_title: 'Редагувати хелпдеск',
      title: 'Хелпдески',
    },
    export_team: {
      create_title: 'Новий член',
      edit_title: 'Редагувати член',
      title: 'Члени команди',
    },
    export_brand_logo: {
      create_title: 'Новий логотип',
      edit_title: 'Редагувати логотип',
      title: 'Логотипи',
    },
    export_brand_file: {
      create_title: 'Новий бренд файл',
      edit_title: 'Редагувати бренд файл',
      title: 'Бренд файли',
    },
    import_handbook_article_type: {
      title: 'Типи довідників імпортера',
      edit_title: 'Редагувати тип',
      create_title: 'Створити тип',
    },
    import_handbook_article: {
      title: 'Довідники імпортера',
      edit_title: 'Редагувати Довідник',
      create_title: 'Створити Довідник',
    },
    import_handbook_category: {
      title: 'Категорії довідників імпортера',
      edit_title: 'Редагувати Категорію',
      create_title: 'Створити Категорію',
    },
    import_handbook_link: {
      title: 'Корисні посилання довідників імпортера',
      edit_title: 'Редагувати посилання',
      create_title: 'Створити посилання',
    },
    entrepreneur_handbook: {
      title: 'Довідники підприємця',
      edit_title: 'Редагувати Довідник підприємця',
      create_title: 'Створити Довідник підприємця',
    },
    expert_activity: {
      title: 'Сфери',
      edit_title: 'Редагувати сферу',
      create_title: 'Створити сферу',
    },
    consultant_request: {
      title: 'Запити',
      edit_title: 'Редагувати запит',
      create_title: 'Створити запит',
    },
    expert_question: {
      title: 'Запитання',
      edit_title: 'Редагувати запитання',
      create_title: 'Створити запитання',
    },
    consultation_category: {
      title: 'Категорії',
      edit_title: 'Редагувати категорію',
      create_title: 'Створити категорію',
    },
    consultation_channel: {
      title: 'Канали',
      edit_title: 'Редагувати канал',
      create_title: 'Створити канал',
    },
    consultation: {
      title: 'Консультації',
      edit_title: 'Редагувати консультацію',
      create_title: 'Створити консультацію',
    },
    event_speaker: {
      title: 'Спікери',
      edit_title: 'Редагувати спікера',
      create_title: 'Створити спікера',
    },
    event_theme: {
      title: 'Теми',
      edit_title: 'Редагувати тему',
      create_title: 'Створити тему',
    },
    event_category: {
      title: 'Категорії',
      edit_title: 'Редагувати категорію',
      create_title: 'Створити категорію',
    },
    expert_review: {
      title: 'Відгуки експертів',
      edit_title: 'Редагувати відгук',
      create_title: 'Створити відгук',
    },
    expert_consultation: {
      title: 'Консультації експертів',
      edit_title: 'Редагувати консультацію',
      create_title: 'Створити консультацію',
    },
    event_propose: {
      title: 'Пропозиції',
      edit_title: 'Редагувати пропозицію',
    },
    consultation_review: {
      title: 'Відгуки консультацій',
      edit_title: 'Редагувати відгук',
      create_title: 'Створити відгук',
    },
    user_enterprise_profile: {
      title: 'Профіль компанії',
      edit_title: 'Редагувати Профіль',
      create_title: 'Створити Профіль',
    },
    user_export_profile: {
      title: 'Профіль експортера',
      edit_title: 'Редагувати Профіль',
      create_title: 'Створити Профіль',
    },
    user_export_catalog_profile: {
      title: 'Профіль для каталогу експортерів',
      edit_title: 'Редагувати Профіль',
      create_title: 'Створити Профіль',
    },
    user_export_catalog_profile_question: {
      title: 'Запити до каталогу',
      edit_title: 'Редагувати Запит',
      create_title: 'Створити Запит',
    },
    user_import_profile: {
      title: 'Профіль імпортера',
      edit_title: 'Редагувати Профіль',
      create_title: 'Створити Профіль',
    },
    user_import_catalog_profile: {
      title: 'Профіль для каталогу імпортера',
      edit_title: 'Редагувати Профіль',
      create_title: 'Створити Профіль',
    },
    notification: {
      title: 'Сповіщення',
      edit_title: 'Редагувати сповіщення',
      create_title: 'Створити сповіщення',
      tab: {
        send: 'Розсилка',
      },
      send_title: 'Розсилка',
    },
    events: {
      title: 'Події',
      edit_title: 'Редагувати подію',
      create_title: 'Створити подію',
      edit_program: 'Редагувати програму',
      edit_registration_form: 'Редагувати регістраційну форму',
      program: 'Програми',
      time: 'Проміжок',
      registrationForm: 'Форма реєстрації',
      usersRegistered: 'Зареєстровані користувачі',
    },
    user_event_registration: {
      title: 'Зворотня форма реєстрації',
      edit_title: 'Редагувати заявку',
    },
    user_education: {
      title: 'Освіта користувача',
      edit_title: 'Редагувати освіту користувача',
    },
    user_education_certificate: {
      title: 'Сертифікати користувача',
      edit_title: 'Редагувати сертифікат користувача',
    },
    idea_category: {
      title: 'Категорії',
      edit_title: 'Редагувати категорію',
      create_title: 'Створити категорію',
    },
    export_category: {
      title: 'Категорії',
      edit_title: 'Редагувати категорію',
      create_title: 'Створити категорію',
    },
    import_category: {
      title: 'Категорії',
      edit_title: 'Редагувати категорію',
      create_title: 'Створити категорію',
    },
    exports: {
      title: 'Експорт',
      edit_title: 'Редагувати експорт',
      create_title: 'Створити експорт',
      material: 'Матеріали',
      edit_material: 'Редагувати матеріали',
      faq: 'FAQ',
      edit_faq: 'Редагувати FAQ',
      contact: 'Контакти',
      edit_contact: 'Редагувати контакти',
    },
    imports: {
      title: 'Імспорт',
      edit_title: 'Редагувати імпорт',
      create_title: 'Створити імпорт',
      material: 'Матеріали',
      edit_material: 'Редагувати матеріали',
      faq: 'FAQ',
      edit_faq: 'Редагувати FAQ',
      contact: 'Контакти',
      edit_contact: 'Редагувати контакти',
    },
    export_service_category: {
      title: 'Категорії сервіса',
      edit_title: 'Редагувати категорію сервіса',
      create_title: 'Створити категорію сервіса',
    },
    export_services: {
      title: 'Сервіс',
      edit_title: 'Редагувати сервіс',
      create_title: 'Створити сервіс',
    },
    'custom-page': {
      title: 'Сторінки',
      edit_title: 'Редагувати сторінку',
      create_title: 'Створити сторінку',
    },
    'custom-breadcrumb': {
      title: 'Хлібні крихти',
      edit_title: 'Редагувати хлібні крихти',
      create_title: 'Створити хлібні крихти',
    },
    export_trade_agreement: {
      title: 'Торгівельні угоди',
      edit_title: 'Редагувати угоду',
      create_title: 'Створити угоду',
    },
    export_service_request: {
      title: 'Запити',
      edit_title: 'Редагувати запит',
      create_title: 'Створити запит',
    },
    export_service_request_report: {
      title: 'Скарги',
      edit_title: 'Редагувати скаргу',
      create_title: 'Створити скаргу',
    },
    tools_services: {
      title: 'Сервіс',
      edit_title: 'Редагувати сервіс',
      create_title: 'Створити сервіс',
    },
    import_service_category: {
      title: 'Категорії сервіса',
      edit_title: 'Редагувати категорію сервіса',
      create_title: 'Створити категорію сервіса',
    },
    import_services: {
      title: 'Сервіс',
      edit_title: 'Редагувати сервіс',
      create_title: 'Створити сервіс',
    },
    entrepreneur_handbook_request: {
      title: 'Запити довідника підприємця',
      edit_title: 'Редагувати запит',
      create_title: 'Створити запит',
    },
    entrepreneur_handbook_question: {
      title: 'Запитання до довідника підприємця',
      edit_title: 'Редагувати запитання',
      create_title: 'Створити запитання',
    },
    export_handbook_question: {
      title: 'Запитання довідника експортера',
      edit_title: 'Редагувати запитання',
      create_title: 'Створити запитання',
    },
    import_trade_agreement: {
      title: 'Торгівельні угоди',
      edit_title: 'Редагувати угоду',
      create_title: 'Створити угоду',
    },
    import_service_request: {
      title: 'Запити',
      edit_title: 'Редагувати запит',
      create_title: 'Створити запит',
    },
    mail: {
      title: 'Email листи',
      edit_title: 'Редагувати Email лист',
      create_title: 'Створити Email лист',
    },
    mail_admin: {
      title: 'Адміністратори розсилки',
      edit_title: 'Редагувати адміністратори розсилки',
      create_title: 'Створити адміністратори розсилки',
    },
    education_category: {
      title: 'Категорії',
      edit_title: 'Редагувати категорію',
      create_title: 'Створити категорію',
    },
    education_format: {
      title: 'Формати',
      edit_title: 'Редагувати формат',
      create_title: 'Створити формат',
    },
    education_organizer: {
      title: 'Організатори',
      edit_title: 'Редагувати організатора',
      create_title: 'Створити організатора',
    },
    education_theme: {
      title: 'Напрямки',
      edit_title: 'Редагувати напрямок',
      create_title: 'Створити напрямок',
    },
    educations: {
      title: 'Освіта',
      edit_title: 'Редагувати освіту',
      create_title: 'Створити освіту',
      program: 'Програма',
      edit_program: 'Редагувати програму',
      edit_results: 'Редагувати результати',
      edit_partners: 'Редагувати партнерів',
      edit_materials: 'Редагувати матеріали',
      feedback_form: 'Зворотня форма',
      edit_feedback_form: 'Редагувати зворотню форму',
      new_material: 'Новий матеріал',
      results: 'Результати',
      partners: 'Партнери',
      materials: 'Матеріали',
    },
    education_review: {
      title: 'Відгуки',
      edit_title: 'Редагувати відгук',
      create_title: 'Створити відгук',
    },
    education_registration: {
      title: 'Реєстрації',
      edit_title: 'Редагувати реєстрацію',
      create_title: 'Створити реєстрацію',
    },
    course_category: {
      title: 'Категорії',
      edit_title: 'Редагувати категорію',
      create_title: 'Створити категорію',
    },
    course_format: {
      title: 'Формати',
      edit_title: 'Редагувати формат',
      create_title: 'Створити формат',
    },
    course_organizer: {
      title: 'Організатори',
      edit_title: 'Редагувати організатора',
      create_title: 'Створити організатора',
    },
    course_theme: {
      title: 'Напрямки',
      edit_title: 'Редагувати напрямок',
      create_title: 'Створити напрямок',
    },
    course_dialog: {
      title: 'Чати',
      edit_title: 'Редагувати чат',
      create_title: 'Створити чат',
      messages: 'Повідомлення',
      send: 'Відправити',
      message: 'Повідомлення',
    },
    user_course: {
      title: 'Курси користувачів',
      edit_title: 'Редагувати курс користувача',
      create_title: 'Створити курс користувача',
      register_form: 'Форма реєстрації',
    },
    user_course_test: {
      title: 'Тести користувачів',
      edit_title: 'Редагувати тесст користувача',
    },
    courses: {
      title: 'Освіта',
      edit_title: 'Редагувати освіту',
      create_title: 'Створити освіту',
      program: 'Програма',
      edit_program: 'Редагувати програму',
      edit_results: 'Редагувати результати',
      edit_partners: 'Редагувати партнерів',
      edit_materials: 'Редагувати матеріали',
      register_form: 'Реєстраційна форма',
      edit_register_form: 'Редагувати реєстраційну форму',
      new_material: 'Новий матеріал',
      results: 'Результати',
      partners: 'Партнери',
      materials: 'Матеріали',
    },
    course_homeworks: {
      title: 'Домашне завдання',
      edit_title: 'Редагувати завдання',
      create_title: 'Створити завдання',
      edit_materials: 'Редагувати матеріали',
      new_material: 'Новий матеріал',
      materials: 'Матеріали',
    },
    course_review: {
      title: 'Відгуки',
      edit_title: 'Редагувати відгук',
      create_title: 'Створити відгук',
    },
    user_lms_teacher_profile: {
      title: 'Профілі',
      edit_title: 'Редагувати профіль',
      create_title: 'Створити профіль',
    },
    user_course_homework: {
      title: 'ДЗ користувачів',
      edit_title: 'Редагувати ДЗ',
      create_title: 'Створити ДЗ',
    },
    user_course_stats: {
      title: 'Статистика',
      edit_title: 'Редагувати статистику',
    },
    uktzed: {
      title: 'УКТЗЕД',
      edit_title: 'Редагувати код',
      create_title: 'Створити код',
    },
    sector: {
      title: 'Сектор',
      edit_title: 'Редагувати Сектор',
      create_title: 'Створити Сектор',
    },
    country_industry: {
      title: 'Індустрії країн',
      edit_title: 'Редагувати Індустрію',
      create_title: 'Створити Індустрію',
    },
    country_partnership_request: {
      title: 'Запити на партнерство країн',
      edit_title: 'Редагувати Запит',
      create_title: 'Створити Запит',
    },
    export_guide_category: {
      title: 'Категорії Експортного гайду',
      edit_title: 'Редагувати Категорію',
      create_title: 'Створити Категорію',
    },
    export_guide: {
      title: 'Експортний гайд',
      edit_title: 'Редагувати гайд',
      create_title: 'Створити гайд',
    },
    import_guide_category: {
      title: 'Категорії Імпортного гайду',
      edit_title: 'Редагувати Категорію',
      create_title: 'Створити Категорію',
    },
    import_guide: {
      title: 'Імпортний гайд',
      edit_title: 'Редагувати гайд',
      create_title: 'Створити гайд',
    },
    ideas: {
      title: 'Ідеї',
      edit_title: 'Редагувати ідею',
      priceUahFrom: 'Ціна UAH від:',
      priceUahTo: 'Ціна UAH до:',
      priceUsdFrom: 'Ціна USD від:',
      priceUsdTo: 'Ціна USD до:',
      documents: 'Документи',
      edit_documents: 'Редагувати документи',
    },
    tests: {
      resultComment: 'Коментар до результату',
      title: 'Тести',
      create_title: 'Створити тест',
      edit_title: 'Редагувати тест',
      edit_questions: 'Редагувати відповіді',
      edit_results: 'Редагувати результати',
      edit_partners: 'Редагувати партнерів',
      partners: 'Партнери',
      question: 'Запитання',
      answer: 'Відповідь',
      point: 'Бали',
      new_question: 'Нове запитання',
      new_answer: 'Нова відповідь',
      pointFrom: 'Бали від',
      pointTo: 'Бали до',
      resultType: 'Тип результата',
      new_result: 'Новий результат',
      result: 'Результат',
      hint: 'Підказка',
      new_section: 'Нова секція',
      page: 'Сторінка',
      title_section: 'Назва секції',
      questionTypeId: 'Тип',
    },
    user_consultation_quiz: {
      title: 'Квізи',
      edit_title: 'Редагувати квіз',
      create_title: 'Створити квіз',
      yes: 'Так',
      no: 'Ні',
      already: 'Вже',
    },
    user_permission: {
      title: 'Дозволи користувача',
      edit_title: 'Редагувати дозвіл',
      create_title: 'Створити дозвіл',
    },
    user_profile_filter: {
      title: 'Фільтри',
      edit_title: 'Редагувати фільтр',
      create_title: 'Створити фільтр',
    },
    editor: {
      title: 'Заголовок',
      alt: 'Мета опис фото',
      description: 'Текст',
      value: 'Значення',
      subtitle: 'Короткий опис',
      city: 'Місто',
      type: 'Тип',
      afterTestResultBlock: 'Блок після результату тесту',
      location: 'Локація',
      address: 'Адреса',
      image: 'Фото',
      organisation: 'Організація',
      duration: 'Тривалість',
      format: 'Формат',
      who: 'Для кого',
      how: 'Для чого',
      price: 'Ціна',
      phone: 'Телефон',
      email: 'Пошта',
      subEmail: 'Додаткова пошта',
      shortDescription: 'Короткий опис',
      content: 'Основний контент',
      btnText: 'Текст кнопки',
      fullName: 'ПІБ',
      formatConsultations: 'Формат консультації',
      consultationAddress: 'Адреса консультації',
      position: 'Позиція',
      creator: 'Розробник',
      partnerBottomText: 'Партнерський текст',
      resultsTitle: 'Результат назва',
      durationLesson: 'Тривалість уроку',
      lessonCount: 'Кількість уроків',
      block1Title: 'Заголовок блоку 1',
      block2Title: 'Заголовок блоку 2',
      block3Title: 'Заголовок блоку 3',
      block4Title: 'Заголовок блоку 4',
      block5Title: 'Заголовок блоку 5',
      block6Title: 'Заголовок блоку 6',
      block7Title: 'Заголовок блоку 7',
      block8Title: 'Заголовок блоку 8',
      block9Title: 'Заголовок блоку 9',
      block10Title: 'Заголовок блоку 10',
      block11Title: 'Заголовок блоку 11',
      block12Title: 'Заголовок блоку 12',
      block13Title: 'Заголовок блоку 13',
      block14Title: 'Заголовок блоку 14',
      block15Title: 'Заголовок блоку 15',
      block16Title: 'Заголовок блоку 16',
      block17Title: 'Заголовок блоку 17',
      block18Title: 'Заголовок блоку 18',
      block19Title: 'Заголовок блоку 19',
      block20Title: 'Заголовок блоку 20',
      block21Title: 'Заголовок блоку 21',
      block22Title: 'Заголовок блоку 22',
      block23Title: 'Заголовок блоку 23',
      block24Title: 'Заголовок блоку 24',
      block25Title: 'Заголовок блоку 25',
      block26Title: 'Заголовок блоку 26',
      block27Title: 'Заголовок блоку 27',
      block28Title: 'Заголовок блоку 28',
      block29Title: 'Заголовок блоку 29',
      block30Title: 'Заголовок блоку 30',
      block1: 'Додатковий блок 1',
      block2: 'Додатковий блок 2',
      block3: 'Додатковий блок 3',
      block4: 'Додатковий блок 4',
      block5: 'Додатковий блок 5',
      block6: 'Додатковий блок 6',
      block7: 'Додатковий блок 7',
      block8: 'Додатковий блок 8',
      block9: 'Додатковий блок 9',
      block10: 'Додатковий блок 10',
      block11: 'Додатковий блок 11',
      block12: 'Додатковий блок 12',
      block13: 'Додатковий блок 13',
      block14: 'Додатковий блок 14',
      block15: 'Додатковий блок 15',
      block16: 'Додатковий блок 16',
      block17: 'Додатковий блок 17',
      block18: 'Додатковий блок 18',
      block19: 'Додатковий блок 19',
      block20: 'Додатковий блок 20',
      block21: 'Додатковий блок 21',
      block22: 'Додатковий блок 22',
      block23: 'Додатковий блок 23',
      block24: 'Додатковий блок 24',
      block25: 'Додатковий блок 25',
      block26: 'Додатковий блок 26',
      block27: 'Додатковий блок 27',
      block28: 'Додатковий блок 28',
      block29: 'Додатковий блок 29',
      block30: 'Додатковий блок 30',
      meta__title: 'Мета заголовок',
      meta__description: 'Мета опис',
      meta__keywords: 'Мета ключові слова',
      meta__robots: 'Мета robots',
      meta__og_title: 'Мета og заголовок',
      meta__og_description: 'Мета og опис',
      meta__og_image: 'Мета og зображення',
      meta__og_type: 'Мета og тип',
      data__title: 'Заголовок',
      data__establishedTitle: 'Заголовок заснування',
      data__subtitle: 'Короткий опис',
      data__description: 'Опис',
      data__location: 'Локація',
      data__address: 'Адреса',
      data__schedule: 'Розклад',
      data__service1: 'Сервіс 1',
      data__service2: 'Сервіс 2',
      data__service3: 'Сервіс 3',
      data__service4: 'Сервіс 4',
      data__shortDescription: 'Короткий опис',
      data__content: 'Основний контент',
      data__components: 'Компоненти',
      data__header: 'Заголовок',
      data__advantages: 'Переваги',
      data__others: 'Інше',
      data__supporters: 'Підтримка',
      data__question: 'Запитання',
      data__answer: 'Відповідь',
      data__meta__title: 'Мета заголовок',
      data__meta__description: 'Мета опис',
      data__meta__keywords: 'Мета ключові слова',
      data__meta__robots: 'Мета robots',
      data__meta__og_title: 'Мета og заголовок',
      data__meta__og_description: 'Мета og опис',
      data__meta__og_image: 'Мета og зображення',
      data__fullName: 'ПІБ',
      data__position: 'Посада',
      data__sidebar: 'Сайдбар',
    },
    log: {
      title: 'Логи',
      edit_title: 'Перегляд логів',
    },
    file: {
      title: 'Файли',
      edit_title: 'Редагувати файл',
      create_title: 'Створити файл',
    },
    admin: 'Адміністратор',
    entrepreneur: 'Підприємиць',
    consultant: 'Консультант',
    marketplace: 'Маркетплейс',
    EKA: 'ЕКА',
    expert: 'Експерт',
    businessAssociation: "Бізнес об'єднання",
    superadmin: 'Суперадмін',
    lmsAdmin: 'LMS',
    months: {
      january: 'Січень',
      february: 'Лютий',
      march: 'Березень',
      april: 'Квітень',
      may: 'Травень',
      june: 'Червень',
      july: 'Липень',
      august: 'Серпень',
      september: 'Вересень',
      october: 'Жовтень',
      november: 'Листопад',
      december: 'Грудень',
    },
    registered_companies: 'Зареєстровані компанії',
    export_companies: 'Експортні компанії',
    import_catalogs: 'Каталоги імпортерів',
    export_catalogs: 'Каталоги експортерів',
    dashboard: {
      services: {
        moderation: 'Нові запити/запити на стадії модерації',
        notModeration: 'Вирішені запити',
        courses: 'Курси користувачів',
        homeworks: 'Домашні завдання',
        tests: 'Тести',
        allTests: 'Тести всього (без проміжку)',
      },
      gender: 'Стать робітників',
      user_tests: 'Пройдені тести користувачів',
      eventRegistrations: 'Реєстрації на події',
      allAttempts: 'Всі спроби',
      expertConsultations: 'Консультації експертів',
      serviceRequests: 'Запити на експортні послуги',
      catalogs: 'Каталоги експортерів',
      users: 'Користувачі',
      importCatalogs: 'Каталоги імпортерів',
      exportCatalogs: 'Каталоги експортерів',
      userEnterpriseProfile: 'Профіль компаній',
      userExportProfile: 'Профіль експортерів',
      userExportCatalogProfile: 'Каталоги імпортерів',
      userImportCatalogProfile: 'Каталоги експортерів',
      companiesForYear: 'Кількість реєстрацій за останній рік',
      education: 'Користувачі навчаються',
      keys: {
        consultantRequests: 'Консультації',
        entrepreneurHandbookRequests: 'Посібник підприємця',
        expertRequests: 'Експертів',
        exportServiceRequests: 'Експортні послуги',
        financeRoleRequests: 'Фінансової ролі',
        tenderRequests: 'Тендери',
        userExportCatalogProfiles: 'Каталоги експортерів',
        userImportCatalogProfiles: 'Каталоги імпортерів',
        active: 'Активні',
        completed: 'Завершені',
        cancel: 'Скасовані',
        maleCount: 'Кількість чоловіків',
        femaleCount: 'Кількість жінок',
        users: 'Користувачі',
        usersActive: 'Активні користувачі',
        all: 'Всі',
        total: 'Всього',
        endCount: 'Завершили',
        startCount: 'Почали',
      },
    },
  },
};
